<template>
  <div class="sw-modal confirm-dialog">
    <div v-click-outside="cancelAction" class="sw-modal-content">
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>Confirm action</h4>
        </div>
      </div>
      <div class="sw-modal-body">
        <div class="row">
          <div class="col-12">
            <span v-html="message"></span>
          </div>
        </div>
        <div class="sw-modal-actions">
          <div class="row">
            <div class="col text-center">
              <button v-if="!hideCancelButton" class="btn btn-secondary" v-on:click.stop="cancelAction()">
                {{cancelButtonText}}
              </button>
              <button class="btn btn-primary" v-on:click.stop="continueAction()">{{continueButtonText}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  components: {},
  props: {
    message: String,
    callbackName: String,
    callbackReference: String,
    continueText: String,
    cancelText: String,
    hideCancelButton: Boolean
  },
  data: function () {
    return {
      canCancel: false
    }
  },
  computed: {
    continueButtonText: function () {
      if (this.continueText) {
        return this.continueText
      } else {
        return 'Continue'
      }
    },
    cancelButtonText: function () {
      if (this.cancelText) {
        return this.cancelText
      } else {
        return 'Cancel'
      }
    }
  },
  methods: {
    cancelAction: function () {
      if (this.canCancel) {
        console.log('cancel')
        this.$root.$emit(this.callbackName)
      }
    },
    continueAction: function () {
      console.log('continue')
      this.$root.$emit(this.callbackName, this.callbackReference)
    }
  },
  mounted () {
    setTimeout(() => {
      this.canCancel = true
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
  @import "../styles/components/modal.scss";
  @import "../styles/components/confirm_dialog.scss";
</style>
